var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ display: _vm.show ? 'block' : 'none' }),attrs:{"id":"loading-overlay"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"lds-default"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])
}]

export { render, staticRenderFns }